/* eslint-disable max-len */
import * as clientRequest from '../helpers/client-request';
import { PrometheusData } from '../../components/types';

let prometheusData: PrometheusData;

export function prometheusCounters(params: PrometheusData) {
    prometheusData = params;
}

export function logClick() {
    clientRequest.doRequest(
        '/distribution-front/external/carousel/count/click' +
            `?type=${prometheusData.type}&channel=${prometheusData.channel}&position=${prometheusData.position}&distribution=${prometheusData.distribution}&adType=${prometheusData.adType}`
    );
}

export function logViewCount(match: boolean) {
    const url =
        '/distribution-front/external/carousel/count/view' +
        `?type=${prometheusData.type}&channel=${prometheusData.channel}&position=${prometheusData.position}&distribution=${prometheusData.distribution}&match=${match}&includeGeo=${prometheusData.includeGeo}&matchType=${prometheusData.matchType}&adType=${prometheusData.adType}`;
    clientRequest.doRequest(url);
}

export function logInscreen() {
    clientRequest.doRequest(
        '/distribution-front/external/carousel/count/inscreen' +
            `?type=${prometheusData.type}&channel=${prometheusData.channel}&position=${prometheusData.position}`
    );
}
